import styled from 'styled-components';
import { Input } from '../../../components/Input';
import { colors } from '../../../constants/Colors';
import { typography } from '../../../helpers/styles/typography';
import { units } from '../../../helpers/styles/units';
import { FontWeight } from '../../../constants/Styles/fontWeight';
import { Button } from '../../../components/Button';
import { TextEditor } from '../../../components/TextEditor';

export const RootWrapper = styled.div`
  position: relative;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding-left: ${units(12)};
  margin-bottom: ${units(63)};
`;
export const NumberInputWrapper = styled.div`
  width: ${units(83)};
`;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(30)};
  padding-top: ${units(20)};
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(12)};

  max-width: ${units(322)};
  width: 100%;
`;

export const CheckboxWrapper = styled(MainWrapper)`
  gap: ${units(12)};
`;

export const FlexWrapper = styled(MainWrapper)`
  gap: ${units(8)};
`;

export const IdInfo = styled.div`
  font-weight: ${FontWeight.MEDIUM};

  color: ${colors.greyDark};
  background-color: ${colors.light};

  ${typography(10)};
`;

export const StyledInput = styled(Input)`
  font-weight: ${FontWeight.REGULAR};
  letter-spacing: 0.8px;

  background-color: ${colors.light};

  ${typography(10)};

  & ::-webkit-calendar-picker-indicator {
    color: transparent;
    background: none;
    z-index: 1;
  }
`;

export const InputWithPlaceholder = styled(Input)`
  font-weight: ${FontWeight.REGULAR};
  letter-spacing: 0.8px;

  background-color: ${colors.light};

  ${typography(10)};

  ::placeholder {
    top: 31px;
  }

  & ::-webkit-calendar-picker-indicator {
    color: transparent;
    background: none;
    z-index: 1;
  }
`;

export const Placeholder = styled.span`
  position: absolute;
  ${typography(10)};
  color: #393836;
  top: 27px;
  z-index: 2;
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;

export const DeleteButton = styled(Button)`
  width: fit-content;
`;

export const Subtitle = styled.div`
  font-weight: ${FontWeight.MEDIUM};

  ${typography(10)};
`;

export const Dicription = styled(Subtitle)`
  font-weight: ${FontWeight.REGULAR};

  color: ${colors.grey20};
`;

export const StyledTextEditor = styled(TextEditor)`
  margin-bottom: 0;
  
  & > p {
    margin-bottom: ${units(8)};

    font-weight: ${FontWeight.MEDIUM};
  }

  & .ql-toolbar.ql-snow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: ${units(28)};
    padding: 6px 16px;

    border-radius: 0px;
    border-color: #c7c7c7;
  }

  & .ql-snow .ql-editor h3 {
    text-align: center;
  }

  & .ql-container.ql-snow {
    border-radius: 0px;
    border-color: #c7c7c7;

    & .ql-editor {
      min-height: ${units(28)};
      padding: 16px 24px;
    }
  }
`;

export const UrlWrapper = styled.div`
  position: relative;
`;

export const CopyWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 16px;
  z-index: 10;
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${units(16)};
`;

export const AddButton = styled(StyledButton)`
  width: fit-content;
  display: flex;
  align-items: center;

  gap: ${units(8)};

  font-weight: ${FontWeight.BOLD};
`;

export const CountInfo = styled.div`
  color: ${colors.grey20};

  ${typography(10)};
`;

export const OrderWrapper = styled.div`
  width: ${units(75)};
`;
